var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44978 1C8.12461 -0.333334 9.81169 -0.333333 10.4865 1L17.6988 15.25C18.3736 16.5833 17.5301 18.25 16.1804 18.25H1.75588C0.406216 18.25 -0.437323 16.5833 0.237509 15.25L7.44978 1Z",
    fill: "#FFC430"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0641 4.625L9.83807 12.5234H8.19438L7.96153 4.625H10.0641ZM7.90674 14.9688C7.90674 14.6354 8.00719 14.3594 8.20808 14.1406C8.41354 13.9167 8.68292 13.8047 9.01623 13.8047C9.3541 13.8047 9.62348 13.9167 9.82437 14.1406C10.0253 14.3594 10.1257 14.6354 10.1257 14.9688C10.1257 15.2917 10.0253 15.5651 9.82437 15.7891C9.62348 16.013 9.3541 16.125 9.01623 16.125C8.68292 16.125 8.41354 16.013 8.20808 15.7891C8.00719 15.5651 7.90674 15.2917 7.90674 14.9688Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.25abc4b4802e0c20ab0e0113fc2880d1.svg";
export { ForwardRef as ReactComponent };